package io.horion.cv.models

data class CvChoice(
    val id: String,
    val label: String,
    val subtitle: String
)

val choices = listOf(
    CvChoice(
        id = "personnal",
        label = "Personnel",
        subtitle = "Créez votre propre style"
    ),
    CvChoice(
        id = "other",
        label = "Pour un tier",
        subtitle = "Faites-le pour un proche"
    )
)
